module.exports = __webpack_public_path__ + "static/media/power_performance_comparative_per_day.b3b7e372.svg";